import * as React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { DropdownMenuContext } from './types';
import * as PropTypes from 'prop-types';

export const withDropdownMenu = <P extends DropdownMenuContext>(Component: React.ComponentType<P>): React.ComponentType<P> => {

  class ComponentWithDropdown extends React.Component<P & { wrappedComponentRef: React.LegacyRef<React.ClassAttributes<P>> }> {

    public static contextTypes: React.ValidationMap<DropdownMenuContext> = {
      handleDropdownHide: PropTypes.func
    };

    public render() {
      const { wrappedComponentRef } = this.props;

      return <Component {...this.props}
        handleDropdownHide={(this.context as DropdownMenuContext).handleDropdownHide}
        ref={wrappedComponentRef} />;
    }
  }

  return hoistStatics(ComponentWithDropdown, Component);
};
